/**
 * 页面常量
 **/
const html = {
  boptt: "泊舟对讲平台",
  talkie: "管理",
  control: "调度",
  platform: "泊舟对讲平台",
  latestIntercomServiceVersion: "最新对讲服务版本:",
  downLoadUrl: "下载地址",
  currentIntercomServiceVersion: "当前对讲服务版本：",
  currentIntercomServiceVersion2: "调度台语音对讲需要使用代理客服端,",
  pleaseUpdate: "请更新"


};

export default html;



// WEBPACK FOOTER //
// ./src/api/lang/modules/constant/html_zh.js